import React, { useState } from "react";
import { sbGetSetting, sbSetSetting } from "../utils/supabaseClient";
import { sendNotification } from "../utils/notifications";
import "../styles/CreateTab.css";

const PromptCreateTab = () => {
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [content, setContent] = useState("");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim() || !content.trim()) {
      setMessage("Title and content are required");
      return;
    }

    setSaving(true);
    try {
      const newPrompt = {
        id: `prompt_${Date.now()}`,
        title: title.trim(),
        cat: category.trim(),
        text: content.trim(),
        addedAt: new Date().toISOString(),
      };

      let prompts = await sbGetSetting("origamic-prompts");
      if (!Array.isArray(prompts)) prompts = [];

      prompts.push(newPrompt);
      await sbSetSetting("origamic-prompts", prompts);

      // Send notification with AI-generated message
      await sendNotification(
        `POWER PROMPT: ${title.trim()}`,
        content.trim().substring(0, 100) + "...",
        "prompts",
        newPrompt.id,
        { type: "prompt", title: title.trim(), category: category.trim(), description: content.trim() }
      );

      setMessage("✅ Prompt saved successfully!");
      setTitle("");
      setCategory("");
      setContent("");

      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Error saving prompt:", err);
      setMessage("❌ Failed to save prompt");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="create-container">
      <h2>Create New Prompt</h2>

      <form onSubmit={handleSubmit} className="create-form">
        <div className="form-group">
          <label>Title *</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="e.g., Marketing Strategy"
            disabled={saving}
          />
        </div>

        <div className="form-group">
          <label>Category</label>
          <input
            type="text"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            placeholder="e.g., Marketing, Strategy, etc."
            disabled={saving}
          />
        </div>

        <div className="form-group">
          <label>Prompt Content *</label>
          <textarea
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="Enter the prompt text here..."
            rows="10"
            disabled={saving}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? "Saving..." : "💾 Save Prompt"}
          </button>
        </div>

        {message && (
          <div className={`message ${message.includes("✅") ? "success" : "error"}`}>
            {message}
          </div>
        )}
      </form>
    </div>
  );
};

export default PromptCreateTab;
